<template>
    <div>
        <PlainTextField
            v-if="plainText"
            :title="title"
            clarity-class="clarity-mask"
            :model-value="id"
            :edit-style="editStyle"
        />
        <VeeField
            v-else
            v-slot="{ value, errors, handleChange, handleBlur, meta }"
            v-model="id"
            :name="name"
            :rules="rules"
            @blur="idToASCII"
            @update:model-value="idToASCII"
        >
            <div>
                <div
                    class="mt-[20px] md:mt-[30px] mb-[10px] font-medium"
                    :class="[{'text-pink-800': errors[0]},
                             !memberStyle ? 'text-black' : 'mt-4']"
                >
                    {{ title }} 
                    <span
                        v-if="!loggedIn && !memberStyle" 
                        class="text-pink-800"
                    >*</span>
                </div>
                <div class="mt-2">
                    <FormTextField
                        :id="inputId"
                        :model-value="value"
                        :max-length="10"
                        autofocus
                        :placeholder="placeholder"
                        :message="inputMessage"
                        :disabled="disabled"
                        :error="!!errors[0] && meta.dirty"
                        :error-message="errors[0]"
                        @update:model-value="handleChange"
                        @keyup="handleBlur"
                    />
                </div>
            </div>
        </VeeField>
    </div>
</template>

<script>
import FormTextField from '@/components/forms/TextField';
import PlainTextField from '@/components/forms/PlainTextField.vue';

export default{
    name:'IdField',
    components:{FormTextField, PlainTextField},
    props:{
        // 內容
        modelValue:{
            type: String,
            default: ''
        },
        // 欄位標題
        title: {
            type: String,
            default: '身分證字號'
        },
        // 檢核覽位名
        name:{
            type: String,
            default: '身分證字號／居留證號／公司統編'
        },
        // input id
        inputId: {
            type: String,
            default: 'AssuredId',
        },
        // input message
        inputMessage: {
            type: String,
            default: '',
        },
        // placeholder
        placeholder: {
            type: String,
            default: '身分證字號／居留證號／公司統編',
        },
        /**
         * 游標是否預設出現
         */
        autofocus: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        // 直接判定錯誤開關
        immediate: {
            type: Boolean,
            default: false
        },
        // 為純顯示非input
        plainText: {
            type: Boolean,
            default: true,
        },
        // 驗證規則
        rules:{
            type: String,
            default: 'required|taiwanId'
        },
        // 是否已登入
        loggedIn:{
            type: Boolean,
            default: false
        },
        // Edit頁style開關
        editStyle: {
            type: Boolean,
            default: false
        },
        // 車主資料頁style開關
        assuredStyle: {
            type: Boolean,
            default: false
        },
        // 會員、續保登入、投保後查詢style開關
        memberStyle: {
            type: Boolean,
            default: false
        },
    },
    emits:['update:modelValue'],
    data(){
        return {
            id: this.modelValue
        };
    },
    methods:{
        /**
         * id 全形字符轉換半形字符
         * 
         * @public
         */
        idToASCII(e) {
            if (e && e.isComposing) return;
            this.id = this.$character.toASCII(this.id);
            this.$emit('update:modelValue', this.id);
        }
    }
};
</script>